import type { SVGProps } from 'react';

const SvgInAppMessages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="in-app-messages"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#232121"
      d="M20.57 9.05h-9.2c-.41 0-.75.34-.75.75v12.4c0 .41.34.75.75.75h9.2c.41 0 .75-.34.75-.75V9.8c0-.41-.34-.75-.75-.75Zm-.75 12.4h-7.7v-10.9h7.7v10.9Z"
    />
    <path
      fill="#232121"
      d="M22.57.32H9.44c-1.49 0-2.7 1.21-2.7 2.7v25.95c0 1.49 1.21 2.7 2.7 2.7h13.13c1.49 0 2.7-1.21 2.7-2.7V3.02c0-1.49-1.21-2.7-2.7-2.7Zm1.2 8.55v20.11c0 .66-.54 1.2-1.2 1.2H9.44c-.66 0-1.2-.54-1.2-1.2V3.02c0-.66.54-1.2 1.2-1.2h13.13c.66 0 1.2.54 1.2 1.2v5.84Z"
    />
    <path fill="#232121" d="M13.38 26.87h4.96v1.5h-4.96z" />
  </svg>
);

export default SvgInAppMessages;
